import { i18n } from '@fs/zion-locale'

export default {
  search: () => i18n.t('dashboardHeader.searchPlaceHolder', 'Search any column'),
}
